import createSlug from 'slug'

export function generateSlug(
	input: { title: string; slug?: string | null },
	opts?: { allowDots?: boolean },
) {
	const { title, slug: slugInput } = input
	const { allowDots = false } = opts ?? {}

	const slug =
		slugInput ??
		createSlug(title, {
			lower: true,
			locale: 'en',
			charmap: allowDots ? { '.': '.' } : {},
		})

	return slug
}
